/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: '3.8rem',
    padding: '.4rem 1.8rem .4rem 1.15rem',
    fontSize: '1rem',
    lineHeight: '1.3125rem',
    backgroundColor: theme.palette.elementBackground,
    borderLeft: `calc(1rem / 16) solid ${theme.palette.border}`,
    borderRight: `calc(1rem / 16) solid ${theme.palette.border}`,
    borderBottom: `calc(1rem / 16) solid ${theme.palette.border}`,
    borderBottomLeftRadius: '.5rem',
    borderBottomRightRadius: '.5rem',
  },
  pageSizeContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: '.25rem',
  },
  pageSizeSelector: {
    marginLeft: '.5rem',
    marginRight: '2rem',
    border: `1px solid ${theme.palette.border}`,
    borderRadius: '.2rem',
    '& div': {
      padding: '.5rem',
    },
  },
  showingResults: {
    margin: '.25rem 0',
  },
  expandIcon: {
    color: theme.palette.expandIcon,
  },
}));

export default useStyles;
